module.exports = __webpack_public_path__ + "539888c4a11cb23406b2b1c43ffc871a.png";